import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[isDefaultSelect]',
  providers: [{ provide: NG_VALIDATORS, useExisting: SelectDefautDirective, multi: true }]
})
export class SelectDefautDirective {

  constructor() { }
  public validate(control: AbstractControl): { [key: string]: any } {
    if(control.value === 0 || control.value===-1)
    {
      return { 'isDefaultSelect': true };
    }
    else 
    {
      return null
    }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/select-defaut.directive.ts